import axios from "@/utils/axios";

export default async function ({ phone }) {
  const response = await axios.post(`user/edit-phone`, { phone });

  return response.data;
}
